import styled from 'styled-components'

export const DraggablesContainer = styled.div`
  display: flex;
  flex-direction: column;
`
